import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiError } from 'app/core/errors/api-error';
import {
  IModalSettings,
  ModalComponent,
} from 'app/domains/shared/components/modal/modal.component';
import { ToastService } from 'app/domains/shared/components/toast/services/toast.service';
import { UsuarioApi } from '../../apis/usuario.api';
import { IUsuarioInativarRequest } from '../../interfaces/usuario-inativar-request.interface';
import { UsuarioCrudHttpService } from '../../services/usuario-crud-http.service';
import { Usuario } from '../../usuario';

@Component({
  selector: 'sgt-form-inativar-usuario-modal',
  templateUrl: './form-inativar-usuario.modal.html',
})
export class FormInativarUsuarioModal implements OnInit, AfterViewInit {
  /** ID do usuário a ser inativado */
  idUsuario: number | null;
  /** Usuário a ser inativado */
  usuario: Usuario | null;

  // Modal settings
  title = 'Inativar Usuário';
  confirmText = 'Inativar';
  cancelText = 'Cancelar';
  settings: IModalSettings = {
    width: '550px',
    allowClickOutsideToClose: false,
    position: 'right',
    hasFooter: true,
  };

  form = new FormGroup({
    justificativa: new FormControl('', [Validators.required, Validators.minLength(15)])
  });

  @ViewChild(ModalComponent) modalRef: ModalComponent;
  @ViewChild('justificativaTextarea') justificativaTextarea: ElementRef<HTMLTextAreaElement>;

  @Output() closed = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<void>();

  constructor(
    private usuarioApi: UsuarioApi,
    private usuarioCrudHttpService: UsuarioCrudHttpService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    if (this.idUsuario) {
      this.fetchUsuario();
    }
  }

  /* Carrega os dados do usuário */
  private fetchUsuario() {
    this.usuarioCrudHttpService.find(this.idUsuario)
        .subscribe({
          next: (usuario) => {
            if (!usuario) {
              this.closeModal();
              return;
            }

            this.usuario = usuario;
          },
          error: (err: ApiError) => {
            this.toastService.error(
              err.message || 'Erro ao buscar dados do usuário.',
              {
                title: err.cause || 'Aconteceu algo inesperado.',
                duration: 5000,
              }
            );
          },
        });
  }

  ngAfterViewInit() {
    if (this.modalRef) {
      setTimeout(() => {
        this.modalRef.open();
        setTimeout(() => this.justificativaTextarea.nativeElement.focus(), 200);
      }, 0);
      this.modalRef.closed.subscribe((result: boolean) => {
        this.closed.emit(result);
      });
    }
  }

  /** Realiza a inativação do usuário */
  submitForm() {
    if (this.form.invalid) {
      return;
    }

    // Criando o payload para inativação
    const payload: IUsuarioInativarRequest = {
      justificativa: this.form.value.justificativa || '',
    };

    // Inativando o usuário
    this.usuarioApi.inativar(this.idUsuario!, payload)
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.toastService.success('Usuário inativado com sucesso.');
          });

          this.confirm();
        },
        error: (error: ApiError) => {
          this.toastService.error(
            error.message || 'Erro ao inativar usuário.',
            {
              title: error.cause || 'Aconteceu algo inesperado.',
              duration: 10000,
            }
          );
        }
      });
  }

  /** Confirma a ação de inativação */
  private confirm() {
    if (this.modalRef) {
      this.modalRef.onConfirm();
      this.confirmed.emit();
    }
    this.closeModal();
  }

  /** Fecha a modal */
  public closeModal() {
    if (this.modalRef) {
      this.modalRef.onClose();
    }
  }
}
